import { ModalBody, ModalContainer, ModalFooter, ModalHeader } from './Modal'
import { ModalManager } from './Manager'
import { ModalWrapper } from './Wrapper'

export { ModalContainer, ModalHeader, ModalBody, ModalFooter, ModalManager, ModalWrapper }
export default {
    ModalContainer,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalManager,
    ModalWrapper,
}
